module.exports = __webpack_public_path__ + "img/TurboFire.b69326e7.jpeg";